import { html } from 'lit-html';

const CloseButtonTemplate = (handleCloseModal: Function) =>
  html`<button @click=${handleCloseModal} class="modal-close icon-cancel" title="Close" aria-hidden="true"></button>`;

export default CloseButtonTemplate;